import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { INPBudgetRequest } from "src/app/shared/models/sap-models/INPBudgetRequest";
import { INPBudget } from "src/app/shared/models/sap-models/inpBudget";
import { catchError, throwError } from "rxjs";
import { WBSBudgetRequest } from "src/app/shared/models/sap-models/WBSBudgetRequest";
import { WBSBudget } from "src/app/shared/models/sap-models/wbsBudget";
import { OtherBudgetRequest } from "src/app/shared/models/sap-models/otherBudgetRequest";
import { OthersBudget } from "src/app/shared/models/sap-models/otherBudget";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class SAPAPI{
    sapAPIURL:string = environment.sapAPIURL;
    sapOfficer:string = environment.sapUserName;
    sapOfficerPwd:string = environment.sapPwd;

    basicAuth:string = this.sapOfficer + ":" + this.sapOfficerPwd;

    httpOptions = {
      headers : new HttpHeaders({
        "Content-Type":"application/json",
        'Authorization':'Basic ' + btoa(this.basicAuth)
  })
};
    
    constructor(private http: HttpClient){

    }

    checkBudgetINP(wbsElement:string){
        const inpObject:INPBudgetRequest = {
            "Method" : "CHECK_BUDG_INP",
            "APP_OFFICER" : this.sapOfficer,
            "WBS_ELEMENT" : wbsElement
        }
        console.log(this.httpOptions);
        return this.http.get<INPBudget[]>(`${this.sapAPIURL}`,this.httpOptions).pipe(catchError(this.error));
    }

    checkBudgetWBS(wbsElement:string){
        const wbsObject:WBSBudgetRequest={
            "Method":"CHECK_BUDG_WBS",
            "WBS_ELEMENT": wbsElement
        }

        return this.http.get<WBSBudget[]>(`${this.sapAPIURL}`, this.httpOptions).pipe(catchError(this.error));
    }
  //handle Errors
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}